/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Rating_YesInputs */

const en_us2_engagement_rating_yes = /** @type {(inputs: Engagement_Rating_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const pt_br2_engagement_rating_yes = /** @type {(inputs: Engagement_Rating_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const es_419_engagement_rating_yes = /** @type {(inputs: Engagement_Rating_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const pt_pt2_engagement_rating_yes = /** @type {(inputs: Engagement_Rating_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const fr_fr2_engagement_rating_yes = /** @type {(inputs: Engagement_Rating_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_de2_engagement_rating_yes = /** @type {(inputs: Engagement_Rating_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_it2_engagement_rating_yes = /** @type {(inputs: Engagement_Rating_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Engagement_Rating_YesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_rating_yes = /** @type {((inputs?: Engagement_Rating_YesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Rating_YesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_rating_yes(inputs)
	if (locale === "es-419") return es_419_engagement_rating_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_rating_yes(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_rating_yes(inputs)
	if (locale === "de-DE") return de_de2_engagement_rating_yes(inputs)
	if (locale === "it-IT") return it_it2_engagement_rating_yes(inputs)
	return en_us2_engagement_rating_yes(inputs)
});
export { engagement_rating_yes as "engagement.rating_yes" }